export default {
  locale: "fr",
  name: "Dates de séjour exclues",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Date de début",
      },
      {
        fieldName: "endDate",
        displayName: "Date de fin",
      },
    ],
    form: [
      {
        fieldName: "startDate",
        displayName: "Date de début",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Entrer une date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
        className: "tickerInput closeButtonInside",
      },
      {
        fieldName: "endDate",
        displayName: "Date de fin",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Entrer une date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
        className: "tickerInput closeButtonInside",
      },
    ],
  },
};
